"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SyncSeek = exports.SyncPullSerialized = exports.SyncDelete = exports.SaveDataTierToDatasync = exports.GetPassThruResult = exports.GetFormValue3Tiers = exports.GetFormSelectedValues = exports.GetDatasyncMediaOneBlock = void 0;
var _datasyncCommonLibrary = require("datasync-common-library");
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const globals = {
  parameters: {
    debugging: true,
    form_modified_version: "2.0"
  }
};

/*  Prototype : _syncDelete
    * Parameter :	JSON object JSON object {"data_guid":"Unique data global id"}
    * Return	:	{remote_data_block:"array of data records"}
    * Purpose 	:   delete data_blob
   *  History   :   Created on 2023-07-27
   *                2024-06-11 : p_s_data_guid, p_onDeleteResult replaced with p_o_syncDeleteParams
   */
const SyncDelete = p_o_syncDeleteParams => {
  console.log("syncDelete::p_o_syncDeleteParams->", p_o_syncDeleteParams);
  console.log("syncDelete::p_s_data_guid->", p_o_syncDeleteParams.data_guid);
  console.log("syncDelete::datasync_url->", p_o_syncDeleteParams.datasync_url);
  if (!p_o_syncDeleteParams.data_guid) {
    console.error("syncDelete -> data_guid not defined");
    return false;
  }
  if (!p_o_syncDeleteParams.on_delete_result_callback) {
    console.error("syncDelete -> p_o_syncDeleteParams.on_delete_result_callback not defined");
    return false;
  }
  (0, _crossFetch.default)(`${(0, _datasyncCommonLibrary.SyncDeleteUrl)(p_o_syncDeleteParams.datasync_url ? p_o_syncDeleteParams.datasync_url : null)}
         &data_guid=${p_o_syncDeleteParams.data_guid}`.replace(/[\n\r]/g, '').replace(/\s{1,}/g, '')).then(results => {
    return results.text();
  }).then(server_answer_as_text => {
    let server_answer_as_object = JSON.parse(server_answer_as_text);
    console.log("SyncDelete:", server_answer_as_object);
    p_o_syncDeleteParams.on_delete_result_callback(p_o_syncDeleteParams.data_guid, server_answer_as_object.deleted_data_count && server_answer_as_object.deleted_data_count > 0, null);
  }).catch(error => {
    console.error("Actions: syncDelete failed with error:", error);
    p_o_syncDeleteParams.on_delete_result_callback(p_o_syncDeleteParams.data_guid, false, error.message);
  });
};

/*  Prototype   : SyncPullSerialized
* Parameter     :	JSON object {guid:"Unique synchronisation session id",block_size:"number of data returned in each request/ default return all"
* Return		:	{remote_data_block:"array of data records"}
* Purpose 	    : Returns prepared required data since given guid session
*  History      : Created on 2022-10-24
*               : 2024-05-11 get url params from p_o_syncPullSerializedParams.SyncPullSerializedGETurl passed back by SyncSeek
*/
exports.SyncDelete = SyncDelete;
const SyncPullSerialized = p_o_syncPullSerializedParams => {
  if (globals.parameters.debugging) console.log(`11:------SyncPullSerialized call - ${p_o_syncPullSerializedParams}`);
  return new Promise((resolve, reject) => {
    let l_o_datasync = {
      session_guid: p_o_syncPullSerializedParams.session_guid,
      block_size: p_o_syncPullSerializedParams.block_size
    };
    let l_s_sync_object_stringified = JSON.stringify(l_o_datasync);
    let l_s_getSyncPullSerialized;
    (0, _crossFetch.default)(`${p_o_syncPullSerializedParams.SyncPullSerializedGETurl}
             &data_sync=${l_s_sync_object_stringified}`.replace(/[\n\r]/g, '').replace(/\s{1,}/g, '')).then(results => {
      return results.text();
    }).then(server_answer_as_text => {
      let server_answer_as_object = JSON.parse(server_answer_as_text);
      if (server_answer_as_object.remote_data_block && server_answer_as_object.remote_data_block.length > 0) {
        if (globals.parameters.debugging) {
          console.log("11:SyncPullSerialized::availables data count:" + server_answer_as_object.remote_data_block.length);
          console.log("11:SyncPullSerialized::availables data flow:" + JSON.stringify(server_answer_as_object.remote_data_block));
        }
        resolve(server_answer_as_object.remote_data_block);
      } else {
        console.log("25:_syncPullserilized::failed");
        resolve({
          remote_data_block: []
        }); //Return empty array
      }
    });
  });
};

/**
 * Prototype: GetDatasyncMediaOneBlock
 * Purpose: Fetch datablob synchronously in one block based on SynPull rather than syncPullSerialized
 * History: copied from getDatasync on 2023-07-15
 *          2024-05-27 axios replaced with fetch using SyncSekk low level function
 * Parameters sync_seek_request_object = {}
 */
exports.SyncPullSerialized = SyncPullSerialized;
const GetDatasyncMediaOneBlock = async p_sync_seek_request_object => {
  if (!p_sync_seek_request_object.session_guid) alert("p_sync_seek_request_object.session_guid required in GetDatasyncMediaOneBlock !!!");
  if (!p_sync_seek_request_object.datasync_url) alert("p_sync_seek_request_object.datasync_url required in GetDatasyncMediaOneBlock !!!");
  try {
    await SyncSeek({
      session_guid: p_sync_seek_request_object.session_guid,
      syncSeekPOSTobject: {
        POST_ACTION: _datasyncCommonLibrary.SyncSeek_action,
        POST_URL: `${p_sync_seek_request_object.datasync_url}/Sync.php`
      },
      SyncPullSerializedGETurl: (0, _datasyncCommonLibrary.SyncMakeGetUrl)(p_sync_seek_request_object.datasync_url, _datasyncCommonLibrary.SyncPullSerialized_action),
      SyncPullSerializedGETurl_STATIC_OBSOLETE: `https://rest.datasync.ovh/Sync.php?action=${_datasyncCommonLibrary.SyncPullSerialized_action}`,
      company_guid: p_sync_seek_request_object.company_guid,
      seek_filter_clause: p_sync_seek_request_object.seek_filter_clause,
      table_guid: p_sync_seek_request_object.table_guid
    }, (p_o_datasyncSeekInfo, p_int_available_data_count) => {
      //Trigger on_media_count_callback
      if (p_sync_seek_request_object.on_media_count_callback) p_sync_seek_request_object.on_media_count_callback(p_int_available_data_count);
      if (p_int_available_data_count > 0) {
        //Data is available

        //Pull data from DataSync layer
        if (p_sync_seek_request_object.debugging) console.log("27:Available data ===> " + p_int_available_data_count);

        //Create an array of promises according to available media items
        let l_array_PullPromises = [];
        if (!p_sync_seek_request_object.one_block_pull) {
          for (let ii = 0; ii < p_int_available_data_count; ii++) l_array_PullPromises.push(SyncPullSerialized({
            SyncPullSerializedGETurl: p_sync_seek_request_object.SyncPullSerializedGETurl,
            session_guid: p_sync_seek_request_object.session_guid,
            date_synchro: p_sync_seek_request_object.date_synchro
          })); //Fetch media data object individually
        } else {
          l_array_PullPromises.push(SyncPullSerialized({
            SyncPullSerializedGETurl: p_sync_seek_request_object.SyncPullSerializedGETurl,
            session_guid: p_sync_seek_request_object.session_guid,
            block_size: p_int_available_data_count
          })); //Fetch Media data object individually
        }

        //Wait for all promises resolution using Promise.all
        Promise.all(l_array_PullPromises).then(media_objects_from_syncPull_promises => {
          let l_array_media_cache = [];
          if (p_sync_seek_request_object.debugging) {
            console.log("27:--------------------------------");
            console.log(`27:JSON.stringify(media_objects_from_syncPull_promises) from DataSync => ${JSON.stringify(media_objects_from_syncPull_promises)}`);
            console.log("27:--------------------------------");
          }

          /** WHY CONVERTING an array into another one ??? 
           * ==> Because data_blob is not yet parsed as object
          */

          if (!p_sync_seek_request_object.one_block_pull) {
            //Fetch available data in one block synchronously
            if (media_objects_from_syncPull_promises)
              //Conditionned on 27-07-2023
              media_objects_from_syncPull_promises.forEach(media_data => {
                let l_o_data_block = media_data[0];
                if (p_sync_seek_request_object.debugging) console.log("27:ONEBLOCK:l_o_data_block:", l_o_data_block);

                //process synchronously each asynchonous fetched record
                if (l_o_data_block && l_o_data_block.data_blob) l_array_media_cache.push(l_o_data_block);
              });

            //Send result back
            if (p_sync_seek_request_object.debugging) console.log("27:l_array_media_cache", l_array_media_cache);
            if (p_sync_seek_request_object.on_media_ready_callback) p_sync_seek_request_object.on_media_ready_callback(l_array_media_cache);
          } else {
            //Fetch available data asynchronously
            if (media_objects_from_syncPull_promises && media_objects_from_syncPull_promises.length > 0 && media_objects_from_syncPull_promises[0].length > 0) {
              //Conditionned enhanced on 2024-10-16
              media_objects_from_syncPull_promises[0].forEach(media_data => {
                let l_o_data_block = media_data;
                if (p_sync_seek_request_object.debugging) console.log("27:ONEBLOCK:l_o_data_block:", l_o_data_block);

                //process synchronously each asynchonous fetched record
                try {
                  l_array_media_cache.push(l_o_data_block);
                } catch (e) {
                  console.error("27:ONEBLOCK:Invalid l_o_data_block.data_blob ", e.message);
                  return false;
                }
              });

              //Finally send result back
              if (p_sync_seek_request_object.on_media_ready_callback) p_sync_seek_request_object.on_media_ready_callback(l_array_media_cache);
            }
          }
        });
      } // else no data available
    }); //end of call SyncSeek Callback function
  } catch (error) {
    //Something went wrong
    console.error("GetDatasyncMediaOneBlock: failed with error:", error);
    if (p_sync_seek_request_object.on_media_failed_callback) p_sync_seek_request_object.on_media_failed_callback(error);
  }
};

/**
 * Purpose : Query a selected field value from data blob
 * History : Created on 2023-04-20
 */
exports.GetDatasyncMediaOneBlock = GetDatasyncMediaOneBlock;
const GetFormSelectedValues = (data_blob_form, requested_field) => {
  let data_blob_form_stringyfied = JSON.stringify(data_blob_form);
  const pattern = new RegExp(`{"name":"${requested_field}",.*?,"selected_values":"(.*?)"`, 'gm');
  /**
   *  Sample from SearchPromises#86
   * l_array_ExecResult = reg_searchTerm.exec(l_sBookTextDataWithoutHtmlTags);
          i = (l_array_ExecResult) ? l_array_ExecResult['index'] : -1;
   */
  let search_result = pattern.exec(data_blob_form_stringyfied);
  if (false) {
    console.log("regex->", search_result);
    console.log("get_form_value->", data_blob_form_stringyfied);
  }
  return search_result ? search_result[1] : "<empty>";
};

/**
 * syncSeek
 * Purpose : Check for a DataTable availability from Datasync givent  a specifit Query clause filter
 * p_oSyncSeekParam:{syncSeekUrl, seek_filter_clause : SQL seek filter, table_guid, company_guid}
 * History : 2024-05-06 axios replaced with fetch
 * 2024-05-08 - new syncSeekPOSTobject parameter
 */
exports.GetFormSelectedValues = GetFormSelectedValues;
const SyncSeek = async (p_oSyncSeekParam, callBack) => {
  let l_o_datasyncSeek = {
    session_guid: p_oSyncSeekParam.session_guid ? p_oSyncSeekParam.session_guid : (0, _datasyncCommonLibrary.CGUID)(),
    date_synchro: '1970-07-10 063050',
    SyncPullSerializedGETurl: p_oSyncSeekParam.SyncPullSerializedGETurl //Broadcast SyncPullSerializedGETurl to callBack function
  };
  let l_s_sync_object_stringified = JSON.stringify(l_o_datasyncSeek);
  if (globals.parameters.debugging) {
    console.log("SyncSeek::p_oSyncSeekParam => ", p_oSyncSeekParam);
  }

  //Prepare SyncSeek POST request
  const POSTform = new FormData();
  POSTform.append("action", p_oSyncSeekParam.syncSeekPOSTobject.POST_ACTION); //
  POSTform.append("company_guid", p_oSyncSeekParam.company_guid);
  POSTform.append("table_guid", p_oSyncSeekParam.table_guid);
  POSTform.append("data_sync", l_s_sync_object_stringified);
  POSTform.append("seek_filter_clause", p_oSyncSeekParam.seek_filter_clause);
  (0, _crossFetch.default)(`${p_oSyncSeekParam.syncSeekPOSTobject.POST_URL}`, {
    method: "POST",
    body: POSTform
  }).then(results => {
    return results.text();
  }).then(server_answer_as_text => {
    //let server_answer_as_object = server_answer_as_text.data;
    let server_answer_as_object = JSON.parse(server_answer_as_text);
    console.log("SyncSeek::server_answer_as_object ->", server_answer_as_object);
    if (server_answer_as_object.available_data_count && server_answer_as_object.available_data_count > 0) {
      //Pull data from DataSync layer
      if (globals.parameters.debugging) console.log("SyncSeek::Available data ===> " + server_answer_as_object.available_data_count);

      //return available_data_count value
      callBack(l_o_datasyncSeek, server_answer_as_object.available_data_count);
    } else {
      if (globals.parameters.debugging) {
        console.log("SyncSeek::Actions: No matching data");
      }

      //Trigger onFetchHandler
      callBack(null, 0);
    }
  }).catch(err => {
    console.error('DsCore fails with error -> ', err);
    if (globals.parameters.debugging) alert(`SyncSeek Error => ${err}`);
  });
};

/**
 * Prototype : getFormValue3Tiers
 * Purpose : Query a field value from new data blob, data_tier property
 */
exports.SyncSeek = SyncSeek;
const GetFormValue3Tiers = (p_data_blob, p_requested_field) => {
  let nextFieldData = "";
  try {
    /** Return data value form field object */
    nextFieldData = p_data_blob.data_tier[p_requested_field] ? p_data_blob.data_tier[p_requested_field] : "";
  } catch (e) {
    if (globals.parameters.debugging) console.log("d3t:getFormValue3Tiers[", p_requested_field, "] nextFieldData->", nextFieldData, " error caught ->", e);
  }
  return nextFieldData;
};

/**
 * Write data_tier form to data blob
 * history : 2024-05-10 new p_s_datasync_url parameter
 */
exports.GetFormValue3Tiers = GetFormValue3Tiers;
const SaveDataTierToDatasync = async (p_s_datasync_url, p_data_guid, p_o_data_blob, p_s_company_guid, p_s_table_guid, p_dt_createstamp, p_dt_updatestamp, p_dt_deletestamp, on_save_handler, on_update_handler, on_failed_handler, p_extra_data) => {
  if (globals.parameters.debugging) console.log(`10/07:this.data_tier:${JSON.stringify(p_o_data_blob)}`);

  //Post object using DataSyncLayer
  //Copy datasync compliant object data from state structure
  let formBlobObject = {
    data_guid: p_data_guid ? p_data_guid : (0, _datasyncCommonLibrary.CGUID)(),
    data_blob: {
      data_tier: p_o_data_blob.data_tier
    }
  };
  if (p_dt_createstamp) {
    formBlobObject.createstamp = p_dt_createstamp;
  }
  if (p_dt_updatestamp) {
    formBlobObject.updatestamp = p_dt_updatestamp;
  }
  if (p_dt_deletestamp) {
    formBlobObject.deletestamp = p_dt_deletestamp;
  }
  let l_o_datasync = Object.assign({}, formBlobObject);
  if (globals.parameters.debugging) {
    console.log("l_o_datasync to be stored => ", l_o_datasync);
  }

  //Set datasync container sytem properties values
  //Set user custom data_blob properties values
  l_o_datasync.data_blob.modified = globals.parameters.form_modified_version; //ReUse modified flag as modified version
  //and so on...

  //Stringify whole datasync object one more time
  let l_s_sync_object_stringified;
  try {
    l_s_sync_object_stringified = JSON.stringify(l_o_datasync).replace(/'/g, "'").replace(/\\n/g, '\\\\n');
    if (globals.parameters.debugging) console.log(`l_s_sync_object_stringified succedeed :${l_s_sync_object_stringified}`);
  } catch (err) {
    console.error(`l_s_sync_object_stringified:${l_s_sync_object_stringified}`);
    if (globals.parameters.debugging) alert(`l_s_sync_object_stringified StringiFy failed with error:${err}`);
  }

  //Prepare datasync syncPush POST request
  const POSTform = new FormData();
  POSTform.append("action", "syncPushSerialized"); //
  POSTform.append("company_guid", p_s_company_guid);
  POSTform.append("table_guid", p_s_table_guid);
  POSTform.append("data_sync", l_s_sync_object_stringified);

  //SyncPush Data
  (0, _crossFetch.default)(`${(0, _datasyncCommonLibrary.SyncPushSerializedUrl)(p_s_datasync_url)}`, {
    method: "POST",
    body: POSTform
  }).then(results => {
    return results.text();
  }).then(sync_server_response => {
    let json_response = JSON.parse(sync_server_response);
    if (globals.parameters.debugging) console.log("json_response ->", json_response);
    if (json_response.data_blob) {
      //Save succedeed
      if (p_data_guid == null && on_save_handler) on_save_handler(json_response, p_extra_data);
      //Update succedeed
      if (p_data_guid != null && on_update_handler) on_update_handler(json_response, p_extra_data);

      //debugging
      if (globals.parameters.debugging) {
        let data_blob = json_response.data_blob;
        console.log("data_blob", data_blob);
      }
    } else {
      //Save or update failed
      console.error("DataSync::saveFormToDatasync => Save or update failed");
      if (on_failed_handler) on_failed_handler("Internal DataSync save error", p_extra_data);
    }
  }).catch(err => {
    console.error(`SaveDataTierToDatasync error => ${err}`);
    if (globals.parameters.debugging) alert(`SaveDataTierToDatasync error => ${err}`);
  });
};

/**
 * Prototype: GetPassThruResult
 * Purpose: Fetch PassThru data asynchronously
 * History: Created on 2023-05-30
 * Parameters sync_seek_request_object = {}
 */
exports.SaveDataTierToDatasync = SaveDataTierToDatasync;
const GetPassThruResult = (p_pass_thru_request_object, on_pass_thru_count_callback, on_pass_thru_ready_callback, on_pass_thru_failed_callback) => {
  //Prepare datasync syncPassThru POST request
  const POSTform = new FormData();
  POSTform.append("action", "syncPassThru"); //
  POSTform.append("select_query", p_pass_thru_request_object.select_query);

  //syncPassThru Data
  (0, _crossFetch.default)(`${p_pass_thru_request_object.syncPassThruUrl}`, {
    method: "POST",
    body: POSTform
  }).then(results => {
    return results.text();
  }).then(server_answer_as_text => {
    let server_answer_as_object = JSON.parse(server_answer_as_text).remote_data_block;
    if (p_pass_thru_request_object.debugging) console.log("23: getPassThruResult::server_answer_as_object -> ", server_answer_as_object);
    if (server_answer_as_object && server_answer_as_object.length > 0) {
      //Send result back
      if (on_pass_thru_ready_callback) on_pass_thru_ready_callback(server_answer_as_object);
    } else {
      console.log("23: getPassThruResult: Pas de creneaux disponibles");
      if (p_pass_thru_request_object.debugging) {
        alert("No availables getPassThruResult data !");
      }

      //Trigger onFetchHandler
      if (on_pass_thru_count_callback) on_pass_thru_count_callback(0);
    }
  }).catch(error => {
    console.error("Actions: syncSeek failed with error:", error);
    if (on_pass_thru_failed_callback) on_pass_thru_failed_callback(error);
  });
};
exports.GetPassThruResult = GetPassThruResult;